module.exports = __webpack_public_path__ + "assets/img/af3411ea4bab4b739830a11bdc5e33c1.svg";